import { useApiClient } from '@/composables/api-client'
import { createItemsStoreWrapper } from '~/utils/pinia/items-store-setup'
import { useFantasyShopSetListStore } from '~/stores/fantasy/shop-set-list'
import type {
  FantasyClaimFreeCardsResponse,
  FantasyShopCard
} from '~/types/fantasy'

const createItemsStore = createItemsStoreWrapper<'id', FantasyShopCard>()

export const useFantasyShopCardsStore = createItemsStore(
  'fantasy-shop-cards',
  {
    path: '/api/v1/fantasy/shop/cards/list',
    idKey: 'id',
    pagination: false,
    query: {
      expand: ['player.team', 'labels', 'cardMember']
    }
  },
  () => {
    const buyCard = async ({
      id,
      updateId
    }: {
      id: number
      updateId: number
    }) => {
      const apiClient = await useApiClient()
      const fantasyShopSetListStore = useFantasyShopSetListStore()
      const data = await apiClient.post(`/api/v1/fantasy/shop/cards/${id}/buy`)
      fantasyShopSetListStore.setBoughtCard(updateId)
      return data
    }

    const claimFreeCards = async () => {
      const apiClient = await useApiClient()
      return apiClient.post<FantasyClaimFreeCardsResponse>(
        '/api/v1/fantasy/shop/cards/free?expand=currentCard.player.team'
      )
    }

    return { buyCard, claimFreeCards }
  }
)
